import React, { createContext, useContext } from "react";
import { Empty, List } from "antd";
import { Observer, observer } from "mobx-react-lite";
import QuaiboDailyProductionStore from "../store/quaibodailyproductionstore";
import { toJS } from "mobx";

import { MessageBar, MessageBarType } from "@fluentui/react";
const QuaiboStoreCtx = createContext(QuaiboDailyProductionStore);
export const QuaiboErrorLogs = observer(() => {
  const quaiboDailyProductionStore = useContext(QuaiboStoreCtx);
  return (
    <Observer>
      {() => (
        <List
          itemLayout="horizontal"
          locale={{
            emptyText: (
              <Empty description={`No upload errors,everything looks great.`} />
            ),
          }}
          dataSource={quaiboDailyProductionStore.uploadErrors.map((x) =>
            toJS(x)
          )}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                description={
                  <MessageBar
                    messageBarType={
                      item.type === "Error"
                        ? MessageBarType.error
                        : MessageBarType.warning
                    }
                  >
                    {item.message}
                  </MessageBar>
                }
              />
            </List.Item>
          )}
        />
      )}
    </Observer>
  );
});

